import { Link } from "@tanstack/react-router";
import { Icon } from "@/components/Icon";
import { SITE } from "@/lib/site-config";

/** Visible E-E-A-T attribution. Shows a named reviewer if configured in
 *  site-config, otherwise credits the advisory team. */
export function ContentByline({
  updated = "June 2026",
  className = "",
}: {
  updated?: string;
  className?: string;
}) {
  const r = SITE.reviewer;
  const hasPerson = r.name.trim().length > 0;
  return (
    <div
      className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-foreground ${className}`}
    >
      <Icon name="badgecheck" color="co" className="h-4 w-4 shrink-0" />
      {hasPerson ? (
        <span>
          Reviewed by{" "}
          <Link to="/about" className="font-medium text-foreground hover:text-accent">
            {r.name}
          </Link>
          {r.title ? `, ${r.title}` : ""}
          {r.credential ? ` · ${r.credential}` : ""}
        </span>
      ) : (
        <span>
          Written &amp; reviewed by the{" "}
          <Link to="/about" className="font-medium text-foreground hover:text-accent">
            {SITE.name} advisory team
          </Link>
        </span>
      )}
      <span aria-hidden>·</span>
      <span>Dallas-Fort Worth business financing advisors</span>
      <span aria-hidden>·</span>
      <span>Updated {updated}</span>
    </div>
  );
}
